import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store =new Vuex.Store({
    state:{
        token:'',
        role:'',
        baseUrl:'https://cdb.0731app.cn/',
        cityArr:[],//城市列表
        mobile:'',
    },
    mutations:{
        setToken(state, token){
            state.token = token;
        },
        setRole(state,role){
            state.role=role;
        },
        setCityArr(state,arr){
            state.cityArr=arr;
        },
        setMobile(state,mobile){
            state.cityArr=mobile;
        }
    },
    actions:{

    }

});


export default store;

